<template>
	<div class="customer_top_wrap">
		<div>{{ $t('cs.title') }}</div>
	</div>
	<div class="container-box">
		<div class="customer_tab_box">
			<!-- <ul class="customer_tab_list">
				<li :class="{ active: currentTab === 'notice' }">
					<a href="/user/cs/notice">{{ $t('cs.notice') }}</a>
				</li>
				<li :class="{ active: currentTab === 'inquiry' }">
					<a href="/user/cs/inquiry">{{ $t('cs.inquiry.inquiry') }}</a>
				</li>
				<li :class="{ active: currentTab === 'inquiry-list' }">
					<a href="/user/cs/inquiry_list">{{ $t('cs.inquiry.list') }}</a>
				</li>
				<li :class="{ active: currentTab === 'faq' }">
					<a href="/user/cs/faq">{{ $t('cs.faq') }}</a>
				</li>
			</ul> -->
		</div>
	</div>
</template>

<script>
export default {
	name: 'CustomerTop',
	props: {
		currentTab: {
			type: String,
			required: true,
		},
	},
};
</script>

<style>
.customer_top_wrap {
	width: 100%;
	height: 225px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-weight: 700;
	font-size: 34px;
	line-height: 36px;
	color: #fff;
	background-image: url('~@/assets/images/v2/bg-customer.png');
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
}
.customer_tab_list {
	display: flex;
	gap: 10px;
	padding: 0;
	margin-top: 80px;
	padding-bottom: 20px;
	border-bottom: 1px solid #f0f0f0;
	margin-bottom: 20px;
}
.customer_tab_list li a {
	font-weight: 500;
	font-size: 16px;
	line-height: 18px;
	color: #cdcdcd;
	height: 48px;
	border: 1px solid #f0f0f0;
	border-radius: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0 20px;
}
.customer_tab_list li.active a {
	font-weight: bold;
	color: #2a5cda;
	border: 1px solid #2a5cda;
}
@media screen and (max-width: 768px) {
	.customer_top_wrap {
		height: 140px;
		font-size: 20px;
		line-height: 22px;
	}
	.customer_tab_box {
		overflow-x: auto;
		/* 스크롤바 숨기기 */
		scrollbar-width: none; /* Firefox */
		-ms-overflow-style: none; /* Internet Explorer 10+ */
	}
	.customer_tab_box::-webkit-scrollbar {
		display: none; /* 웹킷 브라우저에서 스크롤바 숨기기 */
	}
	.customer_tab_list {
		margin-top: 20px;
		padding-bottom: 10px;
		margin-bottom: 10px;
		width: 450px;
	}
	.customer_tab_list li a {
		font-size: 12px;
		height: 38px;
		line-height: 14px;
		padding: 0 12px;
	}
}
</style>
